import React from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import ReactApexChart from 'react-apexcharts';
import ReactDataTable from 'react-data-table-component';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import {
    IconBrandBehance,
    IconBrandFacebook,
    IconBrandGoogleFilled,
    IconBrandInstagram,
    IconBrandLinkedin,
    IconBrandTwitter,
    IconBrandYoutubeFilled,
    IconCamera,
    IconPaperclip
} from '@tabler/icons-react'
import {
    avatar1,
    avatar2,
    avatar3,
} from '../../assets/images';

export default function HrSocial() {

    const chartData1 = {
        series: [
            {
                name: 'Facebook',
                data: [900, 490, 900, 610, 1000, 400, 750, 490, 900, 610, 900, 200],
            },
            {
                name: 'LinkedIn',
                data: [500, 900, 550, 900, 220, 900, 250, 900, 550, 900, 400, 800],
            },
            {
                name: 'Twitter',
                data: [200, 710, 200, 420, 500, 600, 1000, 710, 200, 420, 100, 400],
            }
        ],
        options: {
            dataLabels: {
                enabled: false
            },
            colors: ['var(--chart-color2)', 'var(--chart-color3)', 'var(--chart-color4)'],
            chart: {
                stacked: true,
                toolbar: {
                    show: false,
                },
            },
            tooltip: {
                x: {
                    show: false,
                },
                style: {
                    fontFamily: 'var(--font-family)',
                },
            },
            xaxis: {
                categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                labels: {
                    style: {
                        fontFamily: 'var(--font-family)',
                    },
                },
                tooltip: {
                    enabled: false,
                },
            },
            yaxis: {
                min: 0,
                max: 2500,
                tickAmount: 5,
                labels: {
                    style: {
                        fontFamily: 'var(--font-family)',
                    },
                }
            },
            plotOptions: {
                bar: {
                    columnWidth: '50%',
                },
            },
            legend: {
                position: 'top',
                horizontalAlign: 'center',
            },
            responsive: [{
                breakpoint: 767,
                options: {
                    chart: {
                        height: 'auto'
                    }
                },
            }]
        },
    };

    const columnsFilter = [
        {
            name: 'Media',
            selector: row => row.media,
        },
        {
            name: 'Name',
            selector: row => row.name,
        },
        {
            name: 'Like',
            selector: row => row.like,
            sortable: true,
        },
        {
            name: 'Comment',
            selector: row => row.comment,
            sortable: true,
        },
        {
            name: 'Share',
            selector: row => row.share,
            sortable: true,
        },
        {
            name: 'Member',
            selector: row => row.member,
        },
    ];

    const dataFilter = [
        {
            media: <IconBrandLinkedin className="w-[40px] h-[40px] bg-blue-100 rounded-full text-white p-2 stroke-[1.5]" />,
            name: <><p className="text-[16px]/[19.2px]">LINKED IN</p><p className="text-text-secondary">Florida, United States</p></>,
            like: '19K',
            comment: '14K',
            share: '10K',
            member: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] border border-current text-success rounded'>2341</span>,
        },
        {
            media: <IconBrandTwitter className="w-[40px] h-[40px] bg-sky rounded-full text-white p-2 stroke-[1.5]" />,
            name: <><p className="text-[16px]/[19.2px]">TWITTER</p><p className="text-text-secondary">Arkansas, United States</p></>,
            like: '7K',
            comment: '11K',
            share: '21K',
            member: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] border border-current text-success rounded'>952</span>,
        },
        {
            media: <IconBrandFacebook className="w-[40px] h-[40px] bg-blue-100 rounded-full text-white p-2 stroke-[1.5]" />,
            name: <><p className="text-[16px]/[19.2px]">FACEBOOK</p><p className="text-text-secondary">Illunois, United States</p></>,
            like: '15K',
            comment: '18K',
            share: '8K',
            member: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] border border-current text-success rounded'>6127</span>,
        },
        {
            media: <IconBrandGoogleFilled className="w-[40px] h-[40px] bg-warning rounded-full text-white p-2 stroke-[1.5]" />,
            name: <><p className="text-[16px]/[19.2px]">GOOGLE PLUS</p><p className="text-text-secondary">Arizona, United States</p></>,
            like: '15K',
            comment: '18K',
            share: '154K',
            member: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] border border-current text-success rounded'>325</span>,
        },
        {
            media: <IconBrandYoutubeFilled className="w-[40px] h-[40px] bg-danger-100 rounded-full text-white p-2 stroke-[1.5]" />,
            name: <><p className="text-[16px]/[19.2px]">YOUTUBE</p><p className="text-text-secondary">Alaska, United States</p></>,
            like: '15K',
            comment: '18K',
            share: '200',
            member: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] border border-current text-success rounded'>160</span>,
        },
    ]

    const twitterChat = [
        {
            image: avatar1,
            name: "Chris Fox",
            status: true,
            tagline: "Contrary to popular belief not simply text",
            lastSeen: "1 hours ago"
        },
        {
            image: avatar2,
            name: "Joge Lucky",
            status: false,
            tagline: "Contrary to popular belief not simply text",
            lastSeen: "2 hours ago"
        },
        {
            image: avatar3,
            name: "Isabella",
            status: true,
            tagline: "Contrary to popular belief not simply text",
            lastSeen: "1 day ago"
        },
    ]

    return (
        <>
            <Breadcrumb title="HR Social" path="HR Social" />
            <div className='grid lg:grid-cols-6 sm:grid-cols-3 lg:gap-30 gap-15 mb-30'>
                <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                    <div className='flex flex-col items-center'>
                        <IconBrandLinkedin className='w-[30px] h-[30px] text-blue' />
                        <p className='mt-5'>
                            Followers
                        </p>
                        <p>
                            2510
                        </p>
                    </div>
                </div>
                <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                    <div className='flex flex-col items-center'>
                        <IconBrandInstagram className='w-[30px] h-[30px] text-danger' />
                        <p className='mt-5'>
                            Followers
                        </p>
                        <p>
                            231
                        </p>
                    </div>
                </div>
                <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                    <div className='flex flex-col items-center'>
                        <IconBrandTwitter className='w-[30px] h-[30px] text-sky' />
                        <p className='mt-5'>
                            Followers
                        </p>
                        <p>
                            231
                        </p>
                    </div>
                </div>
                <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                    <div className='flex flex-col items-center'>
                        <IconBrandFacebook className='w-[30px] h-[30px] text-blue' />
                        <p className='mt-5'>
                            Like
                        </p>
                        <p>
                            126
                        </p>
                    </div>
                </div>
                <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                    <div className='flex flex-col items-center'>
                        <IconBrandGoogleFilled className='w-[30px] h-[30px] text-danger' />
                        <p className='mt-5'>
                            Like
                        </p>
                        <p>
                            290
                        </p>
                    </div>
                </div>
                <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                    <div className='flex flex-col items-center'>
                        <IconBrandBehance className='w-[30px] h-[30px] text-blue' />
                        <p className='mt-5'>
                            Project
                        </p>
                        <p>
                            121
                        </p>
                    </div>
                </div>
            </div>
            <div className='bg-bg-dark rounded-lg shadow-light mb-30'>
                <div className='text-[16px]/[19.2px] font-medium md:p-20 p-15'>
                    Social Statistics
                </div>
                <ReactApexChart options={chartData1.options} series={chartData1.series} type="bar" height={300} />
            </div>
            <div className='grid lg:grid-cols-12 grid-cols-1 gap-30 mb-30'>
                <div className='lg:col-span-8 bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                    <div className='text-[16px]/[19.2px] font-medium mb-30'>
                        Social Media
                    </div>
                    <div className='react-data-table'>
                        <ReactDataTable
                            columns={columnsFilter}
                            data={dataFilter}
                            pagination
                        />
                    </div>
                </div>
                <div className='lg:col-span-4'>
                    <div className='flex flex-col gap-30'>
                        <div className='bg-sky rounded-lg shadow-light md:p-20 p-15 text-white'>
                            <Swiper
                                slidesPerView={1}
                                autoplay={{
                                    delay: 1000,
                                    disableOnInteraction: false,
                                }}
                                speed={1500}
                                loop={true}
                                modules={[Autoplay]}
                            >
                                <SwiperSlide>
                                    <div className=''>
                                        <IconBrandTwitter className='text-white mb-5' />
                                        <p>
                                            23th Jan 2024
                                        </p>
                                        <div className='text-[24px]/[28.8px] font-medium md:my-30 my-15'>
                                            Now Get 50% Off <br />
                                            on buy
                                        </div>
                                        <i>
                                            - Post Form Lucid <br />
                                            Thank You
                                        </i>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className=''>
                                        <IconBrandTwitter className='text-white mb-5' />
                                        <p>
                                            23th Jan 2024
                                        </p>
                                        <div className='text-[24px]/[28.8px] font-medium md:my-30 my-15'>
                                            Now Get 50% Off <br />
                                            on buy
                                        </div>
                                        <i>
                                            - Post Form Lucid <br />
                                            Thank You
                                        </i>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className=''>
                                        <IconBrandTwitter className='text-white mb-5' />
                                        <p>
                                            23th Jan 2024
                                        </p>
                                        <div className='text-[24px]/[28.8px] font-medium md:my-30 my-15'>
                                            Now Get 50% Off <br />
                                            on buy
                                        </div>
                                        <i>
                                            - Post Form Lucid <br />
                                            Thank You
                                        </i>
                                    </div>
                                </SwiperSlide>
                            </Swiper>
                        </div>

                        <div className='bg-blue-100 rounded-lg shadow-light md:p-20 p-15 text-white'>
                            <Swiper
                                slidesPerView={1}
                                autoplay={{
                                    delay: 2000,
                                    disableOnInteraction: false,
                                }}
                                speed={1500}
                                loop={true}
                                modules={[Autoplay]}
                            >
                                <SwiperSlide>
                                    <div className=''>
                                        <IconBrandFacebook className='text-white mb-5' />
                                        <p>
                                            23th Jan 2024
                                        </p>
                                        <div className='text-[24px]/[28.8px] font-medium md:my-30 my-15'>
                                            Now Get 50% Off <br />
                                            on buy
                                        </div>
                                        <i>
                                            - Post Form Lucid <br />
                                            Thank You
                                        </i>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className=''>
                                        <IconBrandFacebook className='text-white mb-5' />
                                        <p>
                                            23th Jan 2024
                                        </p>
                                        <div className='text-[24px]/[28.8px] font-medium md:my-30 my-15'>
                                            Now Get 50% Off <br />
                                            on buy
                                        </div>
                                        <i>
                                            - Post Form Lucid <br />
                                            Thank You
                                        </i>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className=''>
                                        <IconBrandFacebook className='text-white mb-5' />
                                        <p>
                                            23th Jan 2024
                                        </p>
                                        <div className='text-[24px]/[28.8px] font-medium md:my-30 my-15'>
                                            Now Get 50% Off <br />
                                            on buy
                                        </div>
                                        <i>
                                            - Post Form Lucid <br />
                                            Thank You
                                        </i>
                                    </div>
                                </SwiperSlide>
                            </Swiper>
                        </div>
                    </div>
                </div>
            </div>
            <div className='grid lg:grid-cols-2 grid-cols-1 gap-30'>
                <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                    <div className='text-[16px]/[19.2px] font-medium mb-30'>
                        Facebook Recent Post
                    </div>
                    <div className='form-group flex mb-20'>
                        <textarea rows={4} placeholder='Please type what you want...' />
                    </div>
                    <div className='flex items-center justify-end gap-10 pb-20 mb-20 border-b border-border'>
                        <button className='btn btn-yellow'>
                            <IconPaperclip className='w-[20px] h-[20px] stroke-[1.5]' />
                        </button>
                        <button className='btn btn-yellow'>
                            <IconCamera className='w-[20px] h-[20px] stroke-[1.5]' />
                        </button>
                        <button className='btn btn-primary'>
                            Post
                        </button>
                    </div>
                    <div className='flex flex-col gap-20'>
                        {twitterChat.map((item, key) => (
                            <div key={key} className='flex items-start justify-between gap-10 group cursor-pointer'>
                                <div className='flex items-center gap-10'>
                                    <div className='relative'>
                                        <img src={item.image} alt='profile' width="40" height="40" className='min-w-[40px] max-w-[40px] min-h-[40px] max-h-[40px] border-2 border-transparent object-cover rounded-full transition-all duration-300 ease-in-out group-hover:border-primary' />
                                        <span className={`inline-block absolute bottom-0 right-0 w-[11px] h-[11px] rounded-full border-2 border-bg-light ${item.status ? 'bg-warning' : 'bg-success'}`}></span>
                                    </div>
                                    <div className='text-left'>
                                        <p className='text-[15px]/[22.5px]'>
                                            {item.name}
                                        </p>
                                        <p className='text-[13px]/[19.5px] text-text-secondary'>
                                            {item.tagline}
                                        </p>
                                    </div>
                                </div>
                                <small className='text-right'>
                                    {item.lastSeen}
                                </small>
                            </div>
                        ))}
                    </div>
                </div>
                <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                    <div className='text-[16px]/[19.2px] font-medium mb-30'>
                        Twitter Feed
                    </div>
                    <div className='form-group flex mb-20'>
                        <textarea rows={4} placeholder='Enter here for tweet...' />
                    </div>
                    <div className='flex items-center justify-between gap-10 pb-20 mb-20 border-b border-border'>
                        <button className='btn btn-primary'>
                            Tweet
                        </button>
                        <button className='text-blue transition-all duration-300 hover:text-blue-100'>
                            13K users active
                        </button>
                    </div>
                    <div className='flex flex-col gap-20'>
                        {twitterChat.map((item, key) => (
                            <div key={key} className='flex items-start justify-between gap-10 group cursor-pointer'>
                                <div className='flex items-center gap-10'>
                                    <div className='relative'>
                                        <img src={item.image} alt='profile' width="40" height="40" className='min-w-[40px] max-w-[40px] min-h-[40px] max-h-[40px] border-2 border-transparent object-cover rounded-full transition-all duration-300 ease-in-out group-hover:border-primary' />
                                        <span className={`inline-block absolute bottom-0 right-0 w-[11px] h-[11px] rounded-full border-2 border-bg-light ${item.status ? 'bg-warning' : 'bg-success'}`}></span>
                                    </div>
                                    <div className='text-left'>
                                        <p className='text-[15px]/[22.5px]'>
                                            {item.name}
                                        </p>
                                        <p className='text-[13px]/[19.5px] text-text-secondary'>
                                            {item.tagline}
                                        </p>
                                    </div>
                                </div>
                                <small className='text-right'>
                                    {item.lastSeen}
                                </small>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    )
}
